export default {
	id: 'SIMPLE_PREMIUM_FALLBACK_12W_59_99_12W_23_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_12w_59_99_12w_23_99_usd',
			EUR: 'simple_premium_12w_59_99_12w_23_99_eur',
			GBP: 'simple_premium_12w_59_99_12w_23_99_gbp',
			AUD: 'simple_premium_12w_99_99_12w_35_19_aud',
			CAD: 'simple_premium_12w_99_99_12w_35_19_cad',
			DKK: 'simple_premium_12w_459_12w_183_2_dkk',
			SEK: 'simple_premium_12w_699_12w_279_2_sek',
			NOK: 'simple_premium_12w_699_12w_279_2_nok',
			BRL: 'simple_premium_12w_179_12w_55_2_brl',
			MXN: 'simple_premium_12w_999_12w_399_2_mxn',
			TRY: 'simple_premium_12w_1999_12w_799_2_try',
			ARS: 'simple_premium_12w_79990_12w_31992_ars',
			COP: 'simple_premium_12w_239990_12w_95992_cop',
			CLP: 'simple_premium_12w_57990_12w_23992_clp',
		},
		primer: 'prd_U4nwbiU4pjZG',
	},
}
